import { z } from 'zod';

export const createActivationSchema = z.object({
  clientId: z.string().min(1, '利用企業を選択してください。'),
  quantity: z
    .string()
    .min(1, '追加人数を入力してください。')
    .regex(/^[1-9]\d*$/, '1以上の整数を入力してください。')
    .refine(val => Number(val) <= 500, {
      error: '追加人数の上限を超えました。500人以下で入力してください。',
    }),
});

export type CreateActivationFormFieldValues = z.infer<typeof createActivationSchema>;
